// add check types (names) and statuses to below variable for when case can no longer be declined
// e.g. below will not allow a case to be decline when ONE_ID status is COMPLETE or IN_PROGRESS
export const checksThatCannotBeDeclined = [
  {
    type: "ONE_ID",
    statuses: ["COMPLETE", "IN_PROGRESS"],
  },
  {
    type: "AUSTRALIAN_DCO",
    statuses: ["APPLICANT_ACTION_REQUIRED"],
  },
];
